// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__24Ug2","colMin":"styles_colMin__1zJA_","colCheckbox":"styles_colCheckbox__2PhCm"};